export class PlatformServicesEnvironmentProvider {
    constructor(userID) {
        this.userID = userID
    }

    async getUrl() {
        const response = await fetch('/ajax/spotler/platform/url')

        return response.json()
    }

    async getAccessToken() {
        const response = await fetch(
            `/ajax/spotler/platform/token/${this.userID}`
        )

        return response.json()
    }
}